/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DailyNavDeliveryError = {
  /**
   * Human-readable explanation. Do not parse it; use `code`.
   */
  detail: string;
  /**
   * Machine-readable reason, stable across releases. `not_finalized` is transient -- the same request succeeds once the day is signed off -- while `not_found` is terminal for that date. A puller should back off and retry on the first and move on from the second.
   */
  code: DailyNavDeliveryError.code;
};
export namespace DailyNavDeliveryError {
  /**
   * Machine-readable reason, stable across releases. `not_finalized` is transient -- the same request succeeds once the day is signed off -- while `not_found` is terminal for that date. A puller should back off and retry on the first and move on from the second.
   */
  export enum code {
    NOT_FOUND = 'not_found',
    NOT_FINALIZED = 'not_finalized',
    NO_REPORT = 'no_report',
    AUTHENTICATION_FAILED = 'authentication_failed',
    PERMISSION_DENIED = 'permission_denied',
  }
}

